import React, { Component, Fragment } from "react";
import { Form, Input, Button, message } from "antd";
import { observer } from "mobx-react";
import { checkBalance } from "services/api";
import co from "co";

const FormItem = Form.Item;

@observer
class RemoteOCR extends Component {
	constructor(props) {
		super(props);
		this.state = {
			checkingBalance: false,
			balance: ""
		}
	}

	checkBalance = () => {
		let params = {
			provider: this.props.provider,
			loginInfo: JSON.stringify({
				address: this.props.form.getFieldValue(this.props.addressField),
				key: this.props.form.getFieldValue(this.props.keyField)
			})
		}		
		co(function*() {
			this.setState({
				checkingBalance: true
			})			
			const response = yield checkBalance(params);						
			if (response == null) {
				message.error("Failed to check balance. Unknown error", 3);
				return;
			}
			if (response.error) {
				message.error("Error: " + response.error.message, 3);
				return;
			}			
			this.setState({
				checkingBalance: false,
				balance: response.balance
			})
		}.bind(this))					
	}

	render() {
		return (
			<Fragment>
				<FormItem label="Server Address">
					{this.props.form.getFieldDecorator(this.props.addressField, {
						rules: [
							{
								required: !this.props.disabled,
								message: "Server Address is Required"
							}
						]
					})(<Input type="text" disabled={this.props.disabled} />)}
				</FormItem>
				<FormItem label="Key">
					{this.props.form.getFieldDecorator(this.props.keyField, {
						rules: [
							{
								required: !this.props.disabled,
								message: "Key is Required"
							}
						]
					})(<Input type="password" disabled={this.props.disabled} />)}
				</FormItem>
				<FormItem>
					<Button loading={this.state.checkingBalance} type="primary" onClick={this.checkBalance}>Check Balance</Button>
				</FormItem>
				<b>Balance:</b> {this.state.balance}
			</Fragment>
		);
	}
}

export default RemoteOCR;
